import { render } from "./SearchPopupComponent.vue?vue&type=template&id=17a55cdd"
import script from "./SearchPopupComponent.vue?vue&type=script&lang=js"
export * from "./SearchPopupComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__